import React from 'react';
import NavBar from '../Components/NavBar';
import styled from 'styled-components'
import MobileNav from '../Components/MobileNav';


const SECTION = styled.section`
background: url(${require('../Assets/Images/car-drive.jpg')});
height: 100vh;
width: 100wh;
background-size: cover;
overflow: hidden;

section {
    @media screen and (max-width: 48rem) {
        z-index: 20;
    display: -webkit-box;
    display: -webkit-fixed;
    display: -ms-fixedbox;
    display: fixed;
    position: fixed;
    top: 40%;
    left: 15%;
    width: 100vw;
    color: white;
    font-size: 1rem;
    bottom: 50%;
    }
    z-index: 20;
    display: fixed;
    position: fixed;
    top: 40%;
    right: 20%;
    width: 60%;
    color: white;
    font-size: 3rem;
    bottom: 50%;
}


`

const OVERLAY = styled.div`
border-radius: .5rem;
position: absolute;
background: purple;
opacity: .8;
width: 100%;
height: 100vh;
overflow: hidden;


`

const HelpCenter = () => {

    return ( 
        <>
<NavBar/>
<MobileNav />
<SECTION>

<OVERLAY />

<section class="than">
    <h3> Thanks for reaching out to us
        <br >
        </br>
        contact us via mail at wealthmeservices@gmail.com
    </h3>
</section>




</SECTION>



        </>
     );
}
 
export default HelpCenter;